export default __webpack_public_path__ + "static/media/schedule.0d828a6f.svg";